import React from 'react'
import { toast } from 'react-toastify';


function CustomToastMessage({ type, message, title }) {
    return (
        <>
            <div className={`toast-custom ${type}`}>
                <div className='d-flex gap-3'>
                    <img
                        src={type === 'success' ? "/images/png/home/check.png" : "/images/png/home/close-toast.png"}
                        alt={type}
                    />
                    <div>
                        <h5>{title}</h5>
                        <h6>{message}</h6>
                    </div>
                </div>
            </div>
        </>
    )
}


const success = message => {
    toast(<CustomToastMessage type="success" title="Success" message={message} />, {
        autoClose: 5000
    });
}

const error = message => {
    toast(<CustomToastMessage type="error" title="Failed" message={message} />, {
        autoClose: 5000
    });
}

export { success, error }

